import { render, staticRenderFns } from "./AdminAddVessel.vue?vue&type=template&id=20c3b832&scoped=true"
import script from "./AdminAddVessel.vue?vue&type=script&lang=js"
export * from "./AdminAddVessel.vue?vue&type=script&lang=js"
import style0 from "./AdminAddVessel.vue?vue&type=style&index=0&id=20c3b832&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c3b832",
  null
  
)

export default component.exports